import { AssemblyDisapprovalType } from "../enums/AssemblyDisapprovalType";

//rule: alphabetic order
export const orderTags = {
  amaro: {
    value: 'marketplace_amaro',
    display: 'Amaro',
    css: null
  },
  influenciadores: {
    value: 'influenciadores',
    display: 'Influenciadores',
    css: null
  },
  non_progressive_order_bf2023: {
    value: 'non-progressive-prescription-order-with-more-than-one-lens',
    display: 'Pedidos "não progressiva" com várias lentes',
    css: null
  },
  externally_changed: {
    value: 'alteracao-externa',
    display: 'Alteração externa',
    css: {
      className: 'externally-changed-order',
      primaryColor: '#993399',
      secondaryColor: '#f0ddee'
    }
  },
  pre_sale_sport: {
    value: 'sport',
    display: 'Pré-venda Sport',
    css: {
      className: 'pre-sale-sport-order',
      primaryColor: '#008000',
      secondaryColor: '#dbead5'
    }
  }
};

export const assemblyDisapprovalOptions = [
  { type: AssemblyDisapprovalType.AssemblyProblem, description: 'Problema na Montagem' },
  { type: AssemblyDisapprovalType.LensProblem, description: 'Problema na Lente' },
  { type: AssemblyDisapprovalType.FrameProblem, description: 'Problema na Armação' },
];